import { useQuery } from '@tanstack/react-query'
import axios from '@pepper/utils/src/function/axiosInstance'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'
import { ApiError } from '@pepper/utils/src/types/domain'

type Props = {
  companyId: string
  uriId?: string
  country?: string
  enabled?: boolean
}

const handleFetch = async (
  companyId: string,
  country?: string,
  uriId?: string
) => {
  const url = `${SEO_SERVICE_BASE_URL}/companies/${companyId}/integrations/ga/properties/validate`
  const response = await axios.get(url, {
    params: {
      country_code: country,
      property: uriId?.split('_')[0]?.replace('properties/', ''),
    },
  })
  return response.data
}

export const useGaValidation = ({
  companyId,
  country,
  uriId,
  enabled,
}: Props) => {
  const { data, error, isLoading } = useQuery<{ data: boolean }, ApiError>({
    queryKey: ['ga-validation', companyId, uriId, country],
    queryFn: () => handleFetch(companyId, country, uriId),
    enabled,
    retry: false,
  })

  return {
    data,
    isLoading,
    error,
  }
}
